import { createContext } from 'react';

import { AccessControlContextState } from './types';

export const AccessControlContext = createContext<AccessControlContextState>(
  {} as never
);
